import { useFetchObjectByCodeQuery } from '@redux/api'

type UseDefaultSortFormProps = {
  objectCode?: string
}

export const useDefaultSortForm = ({ objectCode }: UseDefaultSortFormProps) => {
  const { data: objectForField, isLoading } = useFetchObjectByCodeQuery(objectCode, {
    skip: !objectCode,
    refetchOnMountOrArgChange: true,
  })

  return {
    objectForField,
    isLoading,
  }
}
